import React, { useEffect, useState } from "react";
import { PropertyFilterOperatorFormProps } from "@amzn/awsui-collection-hooks";
import {
  Calendar,
  CalendarProps,
  DateInput,
  DateInputProps,
  DatePicker,
  FormField,
} from "@amzn/awsui-components-console";

// Simplified version compared to AWS-UI-Examples: https://tiny.amazon.com/7txs32s0/codeamazpackAWSUblob7c66src

export const DateForm = ({
  filter,
  onChange,
}: PropertyFilterOperatorFormProps<string>) => {
  // Using the most reasonable default time per operator.
  const [dateValue, setDateValue] = useState<string>("");

  const onChangeDate = (dateValue: string) => {
    setDateValue(dateValue);
  };

  // Parse value from filter text when it changes.
  useEffect(
    () => {
      if (filter) {
        setDateValue(filter.trim());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filter],
  );

  // Call onChange only when the value is valid.
  useEffect(
    () => {
      const trimmedDateValue = dateValue.trim();
      if (!trimmedDateValue) {
        onChange(null);
      } else {
        onChange(trimmedDateValue);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dateValue],
  );

  const dateInputProps: DateInputProps = {
    placeholder: "YYYY/MM/DD",
    value: dateValue,
    onChange: (event) => onChangeDate(event.detail.value),
  };
  const calendarProps: CalendarProps = {
    value: dateValue,
    locale: "en-EN",
    onChange: (event) => onChangeDate(event.detail.value),
  };

  if (typeof filter !== "undefined") {
    return (
      <div className="date-time-form">
        <FormField description="Date">
          <DateInput {...dateInputProps} />
        </FormField>
        <Calendar {...calendarProps} />
      </div>
    );
  }

  return (
    <div className="date-time-form">
      <FormField description="Date">
        <DatePicker {...dateInputProps} {...calendarProps} />
      </FormField>
    </div>
  );
};
